import React, { useState } from 'react';

const GetGoverningBody2 = () => {
    const [loading, setLoading] = useState(true);

    return (
        <div className="text-center my-12">
            <div className="relative inline-block">
                {/* Loading Spinner */}
                {loading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-lg">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
                    </div>
                )}

                {/* Image with Fade-in Effect */}
                <img
                    className={`mx-auto transition-opacity duration-500 ${loading ? "opacity-0" : "opacity-100"}`}
                    src="https://i.ibb.co/35fGRHbv/governi.png"
                    alt="Governing Body"
                    onLoad={() => setLoading(false)}
                />
            </div>
        </div>
    );
};

export default GetGoverningBody2;
